import { useContext, useState } from 'react'
import { Accordion, Button, Flex } from 'src/componentv2'
import ConfigurationApiContext from 'src/provider/API/v2/call-service/configuration'

interface Props {
    open: boolean
    onToggle: (o: boolean) => void
    onSaveAndNext?: () => void
}

export const IndemnitySettings: React.FC<Props> = ({ open, onToggle, onSaveAndNext }) => {
    const { addIndemnityStatement } = useContext(ConfigurationApiContext)

    const [text, setText] = useState('')
    const [saving, setSaving] = useState(false)

    // No prefill: InstitutionProfileDetails doesn't carry the existing statement.
    const handleSave = async () => {
        if (!text) return
        setSaving(true)

        const result = await addIndemnityStatement({ statementContent: text })

        setSaving(false)
        if (result !== false && result !== null) {
            onSaveAndNext?.()
        }
    }

    return (
        <Accordion
            title="Indemnity Settings"
            subtitle="Add an indemnity declaration that users must accept before their transaction limit can be increased"
            open={open}
            onToggle={onToggle}
        >
            <textarea
                className="business-logic__textarea"
                placeholder="Enter indemnity declaration…"
                value={text}
                onChange={(e) => setText(e.target.value)}
                rows={5}
            />

            <Flex justify="flex-end" topMargin="2.4" className="accordion__footer">
                <Button variant="ghost" size="sm" disabled={!text || saving} onClick={handleSave}>
                    {saving ? 'Saving…' : 'Save Changes'}
                </Button>
            </Flex>
        </Accordion>
    )
}

export default IndemnitySettings